import React, {
  useCallback,
  useMemo,
  useRef,
  useEffect,
  useState,
} from "react";
import { connect, useSelector } from "react-redux";
import { Text } from "../../styles/Global";
import { usePlayerRankMutation } from "../../services/playerApi";
import SkeletonLoader from "../../components/SkeletonLoader";
import LinePlot from "./LinePlot";

const MatchHistory = ({ data }) => {
  //   console.log("MatchHistory data: ", data);
  return data ? (
    <div style={{ paddingTop: 25 }}>
      {data && data.length ? (
        <LinePlot
          type="match"
          x="key_as_string"
          y="doc_count"
          autoHeight={true}
          data={data}
        />
      ) : (
        <div
          style={{
            textAlign: "center",
            alignSelf: "center",
            marginTop: 25,
          }}
        >
          <Text>No Game History to display</Text>
        </div>
      )}
    </div>
  ) : (
    <SkeletonLoader h1={200} />
  );
};

export default MatchHistory;
